import React, { useContext } from "react";
import { CircularProgress, Container, Typography } from "@mui/material";
import WithAuth from "../Hoc/WithAuth";
import AuthContext from "../Contexts/authContext";

const Homepage = () => {
  const { authContextInfo } = useContext(AuthContext);
  const { info } = authContextInfo;

  return (
    <Container
      style={{
        width: "100%",
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {info.firstName ? (
        <Typography variant="h5" textAlign="center">
          {`Welcome ${info.firstName} to Kivunova Admin dashboard!`}
        </Typography>
      ) : (
        <Container
          maxWidth="md"
          sx={{
            display: "flex",
            height: "85vh",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
          }}
        >
          Hang tight, authenticating... &nbsp; <CircularProgress size={20} />
        </Container>
      )}
    </Container>
  );
};

export default WithAuth(Homepage);
